import { KpiStatCardProps } from 'pages/ReportsPage/components/AnalyticsDashboards/KpiStatCard';

export const SELECT_COHORT_HINT = 'Select one location and one position to view';
export const SELECT_FILTERS_HINT = 'Select at least one location and one position to view';
const PAY_PERIOD_COMPARISON_TEXT = 'vs. prior pay period';

export function buildErrorCard(label: string): KpiStatCardProps {
  return {
    label,
    value: '--',
    subtitle: 'Failed to load',
    subtitleVariant: 'error',
  };
}

export function buildClearedCard(label: string): KpiStatCardProps {
  return {
    label,
    value: '--',
    subtitle: SELECT_FILTERS_HINT,
  };
}

export function buildValueCard(
  label: string,
  value: string,
  changePrct: number | null,
  comparisonText: string | undefined,
): KpiStatCardProps {
  return {
    label,
    value,
    ...(changePrct != null && {
      changePercentage: changePrct,
      comparisonText,
    }),
  };
}

export function buildCohortGatedCard(params: {
  label: string;
  value: string;
  changePrct: number | null;
  isCohortSelected: boolean;
  hasError: boolean;
  comparisonText?: string;
}): KpiStatCardProps {
  const { label, value, changePrct, isCohortSelected, hasError, comparisonText } = params;

  if (!isCohortSelected) {
    return { label, value: '--', subtitle: SELECT_COHORT_HINT };
  }
  if (hasError) {
    return buildErrorCard(label);
  }
  return buildValueCard(label, value, changePrct, comparisonText ?? PAY_PERIOD_COMPARISON_TEXT);
}
